module.exports = __webpack_public_path__ + "static/media/strategies.d65baee5.svg";